import React, { Component } from 'react';

export class ArcaLogoHeader extends Component {

    constructor(props) {
        super(props);
        this.state = { logo: null };
    }

    render() {
        return (
            <span>
                <img
                    className='centeredImage'

                    alt='Logo'
                    src={require(
                        this.props.isFooter
                            ? '../../../../src/images/footer-logotype.svg'
                        : this.props.isAtTop
                            ? '../../../../src/images/nav-logo big.svg'
                            : '../../../../src/images/nav-logo big.svg')}

                    height={
                        this.props.isFooter
                            ? '140px'
                            : this.props.isAtTop
                            ? this.props.height
                            : '30px'} />
            </span>
        );
    }
}